var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Person = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _spraypaint = require("spraypaint");
var _ApplicationRecord2 = require("./ApplicationRecord");
var _Notification = require("./Notification");
var _NotificationsPreferences = require("./NotificationsPreferences");
var _PeopleTarget = require("./PeopleTarget");
var _User = require("./User");
var _Commitment = require("./Commitment");
var _PersonalChecklistItem = require("./PersonalChecklistItem");
var _PeopleGoal = require("./PeopleGoal");
var _PeopleActionsSuppression = require("./PeopleActionsSuppression");
var _Campaign = require("./Campaign");
var _GroupMembership = require("./GroupMembership");
var _GroupMembershipOrganization = require("./GroupMembershipOrganization");
var _GroupMembershipTeam = require("./GroupMembershipTeam");
var _PeopleAnnouncement = require("./PeopleAnnouncement");
var _PeopleWhatNext = require("./PeopleWhatNext");
var _PeopleClickAnalytic = require("./PeopleClickAnalytic");
var _Organization = require("./Organization");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _class3;
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var Person = exports.Person = (_dec = (0, _spraypaint.Model)(), _dec2 = (0, _spraypaint.Attr)({
  persist: true
}), _dec3 = (0, _spraypaint.Attr)({
  persist: true
}), _dec4 = (0, _spraypaint.Attr)({
  persist: false
}), _dec5 = (0, _spraypaint.Attr)({
  persist: false
}), _dec6 = (0, _spraypaint.Attr)({
  persist: false
}), _dec7 = (0, _spraypaint.Attr)({
  persist: false
}), _dec8 = (0, _spraypaint.Attr)({
  persist: true
}), _dec9 = (0, _spraypaint.Attr)({
  persist: true
}), _dec10 = (0, _spraypaint.Attr)({
  persist: false
}), _dec11 = (0, _spraypaint.Attr)({
  persist: false
}), _dec12 = (0, _spraypaint.Attr)({
  persist: false
}), _dec13 = (0, _spraypaint.Attr)({
  persist: false
}), _dec14 = (0, _spraypaint.Attr)({
  persist: false
}), _dec15 = (0, _spraypaint.Attr)({
  persist: false
}), _dec16 = (0, _spraypaint.Attr)({
  persist: false
}), _dec17 = (0, _spraypaint.Attr)({
  persist: false
}), _dec18 = (0, _spraypaint.Attr)({
  persist: false
}), _dec19 = (0, _spraypaint.Attr)({
  persist: false
}), _dec20 = (0, _spraypaint.Attr)({
  persist: false
}), _dec21 = (0, _spraypaint.Attr)({
  persist: true
}), _dec22 = (0, _spraypaint.Attr)({
  persist: true
}), _dec23 = (0, _spraypaint.Attr)({
  persist: false
}), _dec24 = (0, _spraypaint.Attr)({
  persist: true
}), _dec25 = (0, _spraypaint.Attr)({
  persist: true
}), _dec26 = (0, _spraypaint.Attr)({
  persist: false
}), _dec27 = (0, _spraypaint.Attr)({
  persist: false
}), _dec28 = (0, _spraypaint.Attr)({
  persist: false
}), _dec29 = (0, _spraypaint.Attr)({
  persist: false
}), _dec30 = (0, _spraypaint.HasOne)(_PeopleTarget.PeopleTarget), _dec31 = (0, _spraypaint.HasOne)(_NotificationsPreferences.NotificationsPreferences), _dec32 = (0, _spraypaint.HasMany)(_Commitment.Commitment), _dec33 = (0, _spraypaint.HasMany)(_PersonalChecklistItem.PersonalChecklistItem), _dec34 = (0, _spraypaint.HasMany)(_Notification.Notification), _dec35 = (0, _spraypaint.HasMany)(_PeopleGoal.PeopleGoal), _dec36 = (0, _spraypaint.HasMany)(_PeopleActionsSuppression.PeopleActionsSuppression), _dec37 = (0, _spraypaint.HasMany)(_Campaign.Campaign), _dec38 = (0, _spraypaint.HasMany)(_PeopleWhatNext.PeopleWhatNext), _dec39 = (0, _spraypaint.HasMany)(_GroupMembership.GroupMembership), _dec40 = (0, _spraypaint.HasMany)(_GroupMembershipOrganization.GroupMembershipOrganization), _dec41 = (0, _spraypaint.HasMany)(_GroupMembershipTeam.GroupMembershipTeam), _dec42 = (0, _spraypaint.HasMany)(_PeopleAnnouncement.PeopleAnnouncement), _dec43 = (0, _spraypaint.HasMany)(_PeopleClickAnalytic.PeopleClickAnalytic), _dec44 = (0, _spraypaint.HasMany)(_Organization.Organization), _dec45 = (0, _spraypaint.BelongsTo)(_User.User), _dec(_class = (_class2 = (_class3 = function (_ApplicationRecord) {
  (0, _inherits2["default"])(Person, _ApplicationRecord);
  var _super = _createSuper(Person);
  function Person() {
    var _this;
    (0, _classCallCheck2["default"])(this, Person);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "firstName", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "lastName", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "pendingActionsCount", _descriptor3, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "completeActionsCount", _descriptor4, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "successfulActionsCount", _descriptor5, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "existingActionsCount", _descriptor6, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onboarded", _descriptor7, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "finalized", _descriptor8, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hasUser", _descriptor9, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "kgCo2eEmissions", _descriptor10, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "kgCo2eReductions", _descriptor11, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "kgCo2eForHome", _descriptor12, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "kgCo2eForFood", _descriptor13, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "kgCo2eForTransport", _descriptor14, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "kgCo2eForPurchases", _descriptor15, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "kgCo2eForServices", _descriptor16, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "climateClock", _descriptor17, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "footprintSections", _descriptor18, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "score", _descriptor19, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "locationsRegionId", _descriptor20, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "locationsCountryId", _descriptor21, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "organizationSlugs", _descriptor22, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "householdMemberCount", _descriptor23, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateHouseholdSnapshot", _descriptor24, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "metaHouseholdFootprintKgCo2e", _descriptor25, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "successfulCommitmentLimitPenultimate", _descriptor26, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "successfulCommitmentLimitExceeded", _descriptor27, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "successfulCommitmentLimit", _descriptor28, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "nextTarget", _descriptor29, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "notificationsPreferences", _descriptor30, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "commitments", _descriptor31, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "personalChecklistItems", _descriptor32, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "notifications", _descriptor33, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "goals", _descriptor34, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "actionSuppressions", _descriptor35, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "campaigns", _descriptor36, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "whatsNexts", _descriptor37, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "groupMemberships", _descriptor38, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "groupMembershipOrganizations", _descriptor39, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "groupMembershipTeams", _descriptor40, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "peopleAnnouncements", _descriptor41, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clickAnalytics", _descriptor42, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "organizations", _descriptor43, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "user", _descriptor44, (0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  return (0, _createClass2["default"])(Person);
}(_ApplicationRecord2.ApplicationRecord), (0, _defineProperty2["default"])(_class3, "jsonapiType", 'people'), _class3), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "firstName", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "lastName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "pendingActionsCount", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "completeActionsCount", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "successfulActionsCount", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "existingActionsCount", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onboarded", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "finalized", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "hasUser", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "kgCo2eEmissions", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "kgCo2eReductions", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "kgCo2eForHome", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "kgCo2eForFood", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "kgCo2eForTransport", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "kgCo2eForPurchases", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "kgCo2eForServices", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "climateClock", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "footprintSections", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "score", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "locationsRegionId", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "locationsCountryId", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "organizationSlugs", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "householdMemberCount", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "updateHouseholdSnapshot", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "metaHouseholdFootprintKgCo2e", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "successfulCommitmentLimitPenultimate", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "successfulCommitmentLimitExceeded", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "successfulCommitmentLimit", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "nextTarget", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "notificationsPreferences", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "commitments", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "personalChecklistItems", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "notifications", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "goals", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "actionSuppressions", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "campaigns", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "whatsNexts", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "groupMemberships", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "groupMembershipOrganizations", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "groupMembershipTeams", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "peopleAnnouncements", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "clickAnalytics", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "organizations", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "user", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);